/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type MarketingSessionItemDto = {
  /**
   * 유저 ID
   */
  userId: number;
  /**
   * 닉네임
   */
  nickname: string;
  /**
   * 콘텐츠팩 ID
   */
  packId: string;
  /**
   * 팩 제목
   */
  packTitle: string;
  /**
   * 푼 문항 수 (currentQuizIndex)
   */
  solvedCount: number;
  /**
   * 전체 문항 수
   */
  totalCount: number;
  /**
   * 파생 상태 (진행중/이탈/클리어)
   */
  status: MarketingSessionItemDto.status;
  /**
   * 멈춘 문항 인덱스 (currentQuizIndex)
   */
  stoppedAtIndex: number;
  /**
   * 세션 시작 시각
   */
  startedAt: string;
  /**
   * 마지막 활동 시각 (updatedAt)
   */
  lastActiveAt: string;
};
export namespace MarketingSessionItemDto {
  /**
   * 파생 상태 (진행중/이탈/클리어)
   */
  export enum status {
    IN_PROGRESS = "in_progress",
    CHURNED = "churned",
    CLEARED = "cleared",
  }
}
